import { createContext } from "react";

export interface ClinicUser {
  email: string;
  clinicName: string;
  leadProsthetist: string;
}

export interface AuthContextValue {
  clinicUser: ClinicUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (email: string, password: string) => Promise<void>;
  signup: (user: ClinicUser, password: string) => Promise<void>;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
